import type { StateCreator } from 'zustand';
import type { SchoolContext } from '@gpa-scales/shared-types';

const DEFAULT_CONTEXT: SchoolContext = {
  schoolName: '',
  limitedAP: false,
  districtCompetitiveness: 'average',
};

export interface ContextSlice {
  schoolContext: SchoolContext;
  updateContext: (updates: Partial<SchoolContext>) => void;
  resetContext: () => void;
}

export const createContextSlice: StateCreator<ContextSlice> = (set) => ({
  schoolContext: { ...DEFAULT_CONTEXT },
  updateContext: (updates) =>
    set((state) => ({
      schoolContext: { ...state.schoolContext, ...updates },
    })),
  resetContext: () => set({ schoolContext: { ...DEFAULT_CONTEXT } }),
});
